import { Component, OnInit } from '@angular/core';
import {PressroomShareService} from '../../../../Service/Share/PressroomShareService';
import {PressroomArticle} from '../../../../Model/PressroomArticle';
import {GetMoiService} from '../../../../Service/Share/GetMoiService';

@Component({
  selector: 'app-time-line-content',
  templateUrl: './time-line-content.component.html',
  styleUrls: ['./time-line-content.component.scss']
})
export class TimeLineContentComponent implements OnInit {
  constructor(public pressroomShareService: PressroomShareService, public getMoiService: GetMoiService) { }

  ngOnInit() {

  }

  isAffiche(article: PressroomArticle){
    if (this.pressroomShareService.affichageArticle === 'all'){
      return true;
    }
    const date = new Date(article.date);
    if (date.getFullYear().toString() + (date.getMonth() + 1) === this.pressroomShareService.affichageArticle){
      return true;
    }
    return false;
  }
  getMoiPart(moiAnne){
    let mois;
    console.log(moiAnne);
    mois = moiAnne.substr(5, 2);
    mois = Number(mois).toString();
    return mois;
  }
}
